var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"card-statistics",attrs:{"no-body":""}},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('line-chart',{attrs:{"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }